<template>
  <footer class="site-footer">
    <div class="my-3 klara-logo-text text-center">Beim verwenden von COVIDA gelten unsere AGBs</div>
    <div class="klara-logo-group">
      <div class="klara-logo-text">Powered by</div>
      <a target="_blank" href="https://www.klara.ch">
        <div class="klara-logo">
          <img src="@/assets/img/KLARA_logo.png" />
        </div>
      </a>
    </div>
    <div class="support-logo-group mb-5">
      <div class="klara-logo-text  w-100 text-center">Unterstützt von</div>     
      <div class="support-logo">
        <div class="valiant-logo mt-2">
          <img src="@/assets/img/logo/Valiant.png" />
        </div>
        <div class="suva-logo mt-2">
          <img src="@/assets/img/logo/suva.png" />
        </div>
        <div class="okk-logo mt-2">
          <img src="@/assets/img/logo/okk.png" />
        </div>
        <div class="axon-logo mt-2">
          <img src="@/assets/img/logo/axon.png" />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style>
</style>
